<template>
  <section>
    <div class="wrapper">
      <div>
        <div class="notfound-404">
          <h1>404</h1>

          <h2>We are sorry, the page you requested cannot be found.</h2>
          <p>
            The URL may be misspelled, or the page you're looking for is no longer available.
          </p>
          <router-link class="btn btn-success" to="/">Go To Homepage</router-link>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import PublicNavigation from '../components/Navigations/PublicNavigation.vue';

export default {
  components: { PublicNavigation },
};
</script>

<style lang="scss" scoped>
.wrapper {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
}

.notfound-404 {
  h1 {
    font-size: 186px;
    font-weight: 900;
    margin: 0px;
    text-transform: uppercase;
  }

  h2 {
    font-size: 26px;
    font-weight: 700;
  }

  p {
    font-size: 14px;
    font-weight: 500;
    margin-bottom: 0px;
    text-transform: uppercase;
    margin-bottom: 1rem;
  }

  a,
  button {
    text-transform: uppercase;
  }
}
</style>
